import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: ({ variant }) => theme.typography[variant],
  }),
  { name: 'CustomTypography' }
);
